import { memo } from 'react';
import styled from 'styled-components';
import { ComponentRepresentation } from '@ardoq/basic-components';
import { FlexBox } from '@ardoq/layout';
import { TextOverflow } from '@ardoq/popovers';
import { ComponentItemProps } from '../../components/PropTypes';
import { SelectItemContainer } from '../../components/Atoms';
import { NodeExpander } from '../../components/NodeExpander';

const ComponentContainer = styled(FlexBox)<{ $isDisabled: boolean }>`
  line-height: 30px;
  height: 30px;
  transition:
    background-color 0.3s,
    opacity 0.3s;
  ${({ $isDisabled }) => $isDisabled && 'opacity: 0.5; cursor: not-allowed;'}
`;

const SingleSelectComponentItem = memo(
  ({
    name,
    containerStyle,
    containerClassNames,
    componentRepresentationData,
    iconWrapperClassNames,
    iconWrapperStyle,
    nodeId,
    hasVisibleContent,
    isExpanded,
    isDisabledOption,
    ariaAttributes,
  }: ComponentItemProps) => {
    return (
      <SelectItemContainer data-id={nodeId} className={containerClassNames}>
        <ComponentContainer
          style={containerStyle}
          role="treeitem"
          $isDisabled={isDisabledOption}
          aria-disabled={isDisabledOption}
          {...ariaAttributes}
        >
          <NodeExpander
            hasVisibleContent={hasVisibleContent}
            isExpanded={isExpanded}
            name={name}
          />
          <span className={iconWrapperClassNames} style={iconWrapperStyle}>
            {componentRepresentationData && (
              <ComponentRepresentation
                isImage={componentRepresentationData.isImage}
                value={componentRepresentationData.value}
                icon={componentRepresentationData.icon}
              />
            )}
          </span>
          <TextOverflow
            role="button"
            className="component-name component"
            popoverAcceptsMouse={false}
          >
            {name}
          </TextOverflow>
        </ComponentContainer>
      </SelectItemContainer>
    );
  }
);

export { SingleSelectComponentItem };
